/**
 * Ex:
 *   10000.47 -> 10 000
 *   20000000 -> 20 000 000
 */
export function formatBigInteger(value): string {
    function reverseString(input: string): string {
        return input
            .split('')
            .reverse()
            .join('')
    }

    const roundedValue = Math.round(value)
    const valueStr = roundedValue.toString()
    const reversedValueStr = reverseString(valueStr)
    const reversedValueWithSpaces = reversedValueStr.replace(
        /(\d{3})/g,
        '$1 '
    )

    return reverseString(reversedValueWithSpaces)
}